var fillArray = function fillArray(arr, arrLength, fillItem) {
  if (fillItem === void 0) {
    fillItem = null;
  }

  var newArr = [].concat(arr);

  if (newArr.length !== arrLength) {
    newArr.length = arrLength;
    newArr.fill(fillItem, arr.length);
  }

  return newArr;
};

export default fillArray;